import axiosInstance from '../../Helpers/api_helper';

export const updateUserPassword = async (passwordCurrent: string, newPassword: string): Promise<any> => {
  try {
    const response = await axiosInstance.patch(
      'api/v1/participants/updateMyPassword',
      {
        passwordCurrent: passwordCurrent,
        password: newPassword,
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error updating user password:', error.message);
    throw error;
  }
};